export default __webpack_public_path__ + "static/media/coming-soon.d76e11f6.svg";